import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/custom-statuses/reorder-sequence';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Updates = THIS_API['body']['updates'];
type Output = THIS_API['response'];

const reorderCustomStatuses = async (updates: Updates): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE);
  const response = await noodleApiClient.put(path, { updates });
  return response.data;
};

export default reorderCustomStatuses;
